import React, { useState, useEffect } from 'react';
import './Customers.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const Customers = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [showCustomerDetail, setShowCustomerDetail] = useState(false);

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/customers`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) {
        setCustomers(data.data);
      }
    } catch (error) {
      console.error('Error fetching customers:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCustomerDetail = async (id) => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/customers/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) {
        setSelectedCustomer(data.data);
        setShowCustomerDetail(true);
      }
    } catch (error) {
      console.error('Error fetching customer detail:', error);
    }
  };

  const filteredCustomers = customers.filter(c => {
    if (!searchTerm) return true;
    const search = searchTerm.toLowerCase();
    return (
      c.email?.toLowerCase().includes(search) ||
      `${c.first_name} ${c.last_name}`.toLowerCase().includes(search)
    );
  });

  if (loading) {
    return <div className="customers-loading">Loading customers...</div>;
  }

  return (
    <div className="customers-management">
      <div className="customers-header">
        <input
          type="text"
          placeholder="Search customers..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="customers-table-container">
        <table className="customers-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Total Orders</th>
              <th>Total Spent</th>
              <th>Joined</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredCustomers.map(customer => (
              <tr key={customer.id}>
                <td className="customer-name">
                  {customer.first_name} {customer.last_name}
                </td>
                <td>{customer.email}</td>
                <td>{customer.total_orders || 0}</td>
                <td className="customer-spent">${parseFloat(customer.total_spent || 0).toFixed(2)}</td>
                <td>{new Date(customer.created_at).toLocaleDateString()}</td>
                <td>
                  <button className="btn-view" onClick={() => fetchCustomerDetail(customer.id)}>
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showCustomerDetail && selectedCustomer && (
        <div className="modal-overlay" onClick={() => setShowCustomerDetail(false)}>
          <div className="modal-content customer-detail-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{selectedCustomer.first_name} {selectedCustomer.last_name}</h3>
              <button className="btn-close" onClick={() => setShowCustomerDetail(false)}>×</button>
            </div>

            <div className="customer-detail-content">
              <div className="customer-section">
                <h4>Contact Information</h4>
                <p><strong>Email:</strong> {selectedCustomer.email}</p>
                <p><strong>Joined:</strong> {new Date(selectedCustomer.created_at).toLocaleDateString()}</p>
              </div>

              <div className="customer-section">
                <h4>Statistics</h4>
                <div className="customer-stats">
                  <div className="stat-item">
                    <div className="stat-value">{selectedCustomer.total_orders || 0}</div>
                    <div className="stat-label">Total Orders</div>
                  </div>
                  <div className="stat-item">
                    <div className="stat-value">${parseFloat(selectedCustomer.total_spent || 0).toFixed(2)}</div>
                    <div className="stat-label">Total Spent</div>
                  </div>
                </div>
              </div>

              <div className="customer-section">
                <h4>Order History</h4>
                {selectedCustomer.orders && selectedCustomer.orders.length > 0 ? (
                  <div className="customer-orders">
                    {selectedCustomer.orders.map(order => (
                      <div key={order.id} className="customer-order">
                        <div className="order-info">
                          <div className="order-number">{order.order_number}</div>
                          <div className="order-date">{new Date(order.created_at).toLocaleDateString()}</div>
                        </div>
                        <div className="order-details">
                          <span className="order-items">{order.item_count} items</span>
                          <span className="order-total">${order.total.toFixed(2)}</span>
                        </div>
                        <span className="order-status" style={{ 
                          background: order.status === 'delivered' ? '#e8f5e9' : '#fff3e0',
                          color: order.status === 'delivered' ? '#2e7d32' : '#e65100'
                        }}>
                          {order.status}
                        </span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="no-orders">No orders yet</p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Customers;
